import { useNewNavigate, useSelectedPersonValue } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Center, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { RoomInfo, Thumbnail } from "./components";
import { PersonCount } from "./components/personCount";
import { CustomButton, CustomPrice, Wrapper } from "./roomCard.style";
import { RoomCardProps } from "./types";

export const RoomCard = ({ dayNight, currentRoom, onRoomSelection }: RoomCardProps) => {
    const { state, onNavigate } = useNewNavigate();
    const [isChoiceRoom, setIsChoiceRoom] = useState(false);
    const selectedPersonValue = useSelectedPersonValue();
    const {
        imgUrl,
        isAvailableBook,
        amountOfImgs,
        roomIdx,
        roomDetailInfo,
        isPaidSite,
        isPriceOff,
        price,
        addFee,
        addPerson,
    } = currentRoom;
    const { name, personOfCapacity, structure } = roomDetailInfo;
    const [newOnPrice, setNewOnPrice] = useState(price.normal);
    const [newOffPrice, setNewOffPrice] = useState(price.discount);
    const discountRate = Math.round(100 - (newOffPrice / newOnPrice) * 100);

    const handleChoiceRoom = () => {
        setIsChoiceRoom((prev) => !prev);

        if (isChoiceRoom) {
            setNewOnPrice(price.normal);
            setNewOffPrice(price.discount);
        }
    };

    useEffect(() => {
        if (state) {
            const selectedRoom = Number(currentRoom.roomIdx) === state.roomIdx;

            if (selectedRoom) {
                setIsChoiceRoom(true);
            }
            onNavigate({ path: "/reserve" });
        }
    }, []);
    useEffect(() => {
        const params = {
            roomIdx: currentRoom.roomIdx,
            isSelected: isChoiceRoom,
            newOffPrice,
            person: { ...selectedPersonValue },
        };

        onRoomSelection(params);
    }, [isChoiceRoom, newOffPrice]);

    const { isTablet } = MEDIA();

    return (
        <Wrapper
            w="100%"
            p={isTablet ? "0" : "24px"}
            boxSizing="border-box"
            columnGap="64px"
            flexDir={isTablet ? "column" : "row"}
            rowGap={isTablet ? "32px" : "auto"}
            alignItems={"flex-end"}
        >
            <Center
                w="100%"
                flexDir={isTablet ? "column" : "row"}
                alignItems={isTablet ? "flex-start" : "auto"}
                rowGap={isTablet ? "32px" : "auto"}
            >
                <Center w="100%">
                    <Center
                        w="100%"
                        columnGap="24px"
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        rowGap={isTablet ? "24px" : "auto"}
                        flexDir={isTablet ? "column" : "row"}
                    >
                        <Thumbnail
                            amountOfImgs={amountOfImgs}
                            imgUrl={imgUrl}
                            isAvailableBook={isAvailableBook}
                            roomIdx={roomIdx}
                            roomName={name}
                        />
                        <RoomInfo
                            isPriceOff={isPriceOff}
                            name={name}
                            discountRate={discountRate}
                            isAvailableBook={isAvailableBook}
                            personOfCapacity={personOfCapacity}
                            structure={structure}
                        />
                    </Center>
                </Center>
                {isChoiceRoom && !isPaidSite && (
                    <Center w={isTablet ? "100%" : "auto"}>
                        <PersonCount
                            addFee={addFee}
                            addPerson={addPerson}
                            personOfCapacity={personOfCapacity}
                            setNewOnPrice={setNewOnPrice}
                            setNewOffPrice={setNewOffPrice}
                            initialOnPrice={price.normal}
                            initialOffPrice={price.discount}
                        />
                    </Center>
                )}
            </Center>
            <Center
                h="100%"
                flexDir={isTablet ? "row" : "column"}
                rowGap="16px"
                columnGap={isTablet ? "16px" : "auto"}
                alignItems="flex-end !important"
                justifyContent="flex-end !important"
            >
                {isAvailableBook && (
                    <Flex flexDir="column" alignItems="flex-end">
                        {newOnPrice > newOffPrice && (
                            <CustomPrice textDecoration="line-through">
                                {Math.floor(newOnPrice).toLocaleString()}원
                            </CustomPrice>
                        )}
                        <CustomPrice alignItems="center" columnGap="4px">
                            <Text flexShrink={0}>{dayNight}박</Text>
                            <Text fontSize="24px" fontWeight={700} pl="4px" boxSizing="border-box">
                                {Math.floor(newOffPrice).toLocaleString()}
                            </Text>
                            <Text>원</Text>
                        </CustomPrice>
                    </Flex>
                )}
                <CustomButton
                    size="medium"
                    disabled={!isAvailableBook}
                    className={isChoiceRoom ? "check" : ""}
                    isAvailableBook={isAvailableBook}
                    onClick={handleChoiceRoom}
                >
                    {isAvailableBook ? "객실 선택" : "예약 마감"}
                </CustomButton>
            </Center>
        </Wrapper>
    );
};
